export default "__VITE_PUBLIC_ASSET__93869267__"